import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import {
  Typography,
  Box,
  IconButton,
  Table,
  TableContainer,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Dialog,
  DialogTitle,
  DialogActions,
  Switch,
} from "@mui/material";
import MyAppsFunctions from "./MyAppsFunctions";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";
import { Form, Button } from "react-bootstrap";
import styles from "./MyAppsDetail.module.css";

const UserTable = ({
  Apps,
  isSomethingChanged,
  setIsSomethingChanged,
  role,
  highlightedWorkspaceIds,
  highlightSubByWorkspace,
}) => {
  const isSuperAdmin = role === "super_admin";
  const [hiddenById, setHiddenById] = React.useState({});
  React.useEffect(() => {
    const initial = {};
    for (const a of Apps || []) initial[a.id] = !!a.hidden_for_members;
    setHiddenById(initial);
  }, [Apps]);
  const toggleHidden = async (id, nextHidden) => {
    setHiddenById((prev) => ({ ...prev, [id]: nextHidden }));
    try {
      const res = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/toggle_workspace_visibility`,
        {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id, hidden: nextHidden }),
        },
      );
      if (!res.ok) throw new Error("toggle failed");
    } catch (e) {
      // revert on failure
      setHiddenById((prev) => ({ ...prev, [id]: !nextHidden }));
      console.log("[hide_for_members] workspace toggle failed:", e?.message);
    }
  };
  // Selected workspace is URL-controlled (?workspaceId=NN) so pressing the
  // browser Back button after drilling into a workspace pops back to the list
  // — WITH the parent's search/filters intact, since those live in the same
  // URL. Resolves the ID against the current Apps list on every render.
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedWorkspaceId = searchParams.get("workspaceId");
  const selectedCard = React.useMemo(() => {
    if (!selectedWorkspaceId) return null;
    const idNum = Number(selectedWorkspaceId);
    return (
      (Apps || []).find(
        (a) => String(a?.id) === String(selectedWorkspaceId) || a?.id === idNum,
      ) || null
    );
  }, [Apps, selectedWorkspaceId]);
  const [updateCampaignDialougeOpen, setdUpdateCampaignDialougeOpen] =
    React.useState(false);
  const [showEdit, setShowEdit] = React.useState(false);

  // EDIT FORM STATES
  const [workspace_name, setWorkspace_name] = useState("");
  const [description, setDescription] = useState("");
  const [paymentType, setPaymentType] = useState("US");
  const [workspaceName, setWorkspaceName] = useState("");
  const [ownerEmail, setOwnerEmail] = useState("");
  const [region, setRegion] = useState("");
  const [avgSavings, setAvgSavings] = useState("");
  const [company, setCompany] = useState("");
  const [address, setAddress] = useState("");
  const [taxId, setTaxId] = useState("");
  const [phone, setPhone] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");
  const [customerId, setCustomerId] = useState("");
  const [customerIdZoho, setCustomerIdZoho] = useState("");
  const [customerIdRzp, setCustomerIdRzp] = useState("");

  // Push a new history entry when drilling in (so Back exits the detail),
  // and replace when clearing (so back-from-list doesn't loop).
  const handleCardClick = (cardData) => {
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        if (cardData && cardData.id != null) {
          next.set("workspaceId", String(cardData.id));
          // A DB-id search (sub:315, bill:456 …) knows which sub the
          // admin is after; carry it so the detail view highlights it.
          const subId = highlightSubByWorkspace?.[cardData.id];
          if (subId) next.set("highlightSub", String(subId));
          else next.delete("highlightSub");
        } else {
          next.delete("workspaceId");
        }
        return next;
      },
      { replace: cardData == null },
    );
  };

  function convertUTCToIST(utcTimeString) {
    const isoString = `1970-01-01T${utcTimeString.replace("Z", "")}Z`;
    const date = new Date(isoString);
    const istOffset = 5.5 * 60 * 60 * 1000;
    const istDate = new Date(date.getTime() + istOffset);
    const pad = (n) => n.toString().padStart(2, "0");
    const hours = pad(istDate.getUTCHours());
    const minutes = pad(istDate.getUTCMinutes());
    const seconds = pad(istDate.getUTCSeconds());
    return `${hours}:${minutes}:${seconds}`;
  }

  return (
    <div style={{ marginTop: "20px" }}>
      <Dialog
        PaperProps={{
          style: { borderRadius: "20px" },
        }}
        open={updateCampaignDialougeOpen}
      >
        <div
          style={{
            width: "500px",
            height: "200px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div style={{ width: "100%" }}>
            <CloseIcon
              sx={{
                float: "right",
                color: "black",
                height: "4vh",
                mx: 2,
                mt: 3,
                cursor: "pointer",
              }}
              onClick={() => {
                setdUpdateCampaignDialougeOpen(false);
              }}
            />
          </div>
          <DialogTitle id="alert-dialog-title" sx={{ mt: 0, pt: 0 }}>
            <p
              style={{ color: "#EF6D6D", fontWeight: "bold", fontSize: "20px" }}
            >
              Update Status of Expense!!
            </p>
          </DialogTitle>
          <DialogActions sx={{ mb: 4, float: "right" }}>
            <Button
              onClick={() => setdUpdateCampaignDialougeOpen(false)}
              variant="contained"
              sx={{ color: "#fff" }}
              color="error"
            >
              Cancel
            </Button>
            <Button variant="contained" sx={{ color: "#fff" }} color="success">
              Verify
            </Button>
          </DialogActions>
        </div>
      </Dialog>

      {selectedCard !== null && (
        <>
          <Box sx={{ width: "100%", display: "inline-flex", mb: 4 }}>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                height: "5vh",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-around",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <IconButton
                    sx={{ float: "left" }}
                    disabled={selectedCard === null}
                    variant="contained"
                    onClick={() => handleCardClick(null)}
                  >
                    <ArrowBackIcon />
                  </IconButton>
                  <Typography
                    sx={{ fontSize: "18px", fontWeight: 700, float: "left" }}
                  >
                    <span
                      dangerouslySetInnerHTML={{ __html: selectedCard.name }}
                    />
                  </Typography>
                </div>
              </Box>
              <div sx={{ display: "flex" }}>
                <button
                  style={{
                    backgroundColor: "#3182ce",
                    height: "2re,",
                    width: "4rem",
                    padding: "5px",
                    color: "white",
                    borderRadius: "4px",
                    border: "none",
                  }}
                  onClick={() => setShowEdit(true)}
                >
                  Edit
                </button>
              </div>
            </Box>
          </Box>

          {
            <MyAppsFunctions
              selectedCard={selectedCard}
              isSomethingChanged1={isSomethingChanged}
              setIsSomethingChanged1={setIsSomethingChanged}
              role={role}
            />
          }
        </>
      )}
      {selectedCard === null && (
        <>
          <div style={{ minHeight: "100px" }}>
            <TableContainer>
              <Table
                aria-label="sticky table"
                style={{
                  borderCollapse: "separate",
                  borderSpacing: "0px 10px",
                }}
              >
                <TableHead>
                  <TableRow>
                    <TableCell
                      align="left"
                      style={{
                        top: 57,
                        minWidth: 150,
                        background: "#F2F1EB",
                        fontSize: "15px",
                        fontWeight: "bold",
                      }}
                    >
                      Workspace Name
                    </TableCell>
                    <TableCell
                      align="left"
                      style={{
                        top: 57,
                        minWidth: 150,
                        background: "#F2F1EB",
                        fontSize: "15px",
                        fontWeight: "bold",
                      }}
                    >
                      Paid
                    </TableCell>
                    <TableCell
                      align="left"
                      style={{
                        top: 57,
                        minWidth: 150,
                        background: "#F2F1EB",
                        fontSize: "15px",
                        fontWeight: "bold",
                      }}
                    >
                      Payment
                    </TableCell>
                    <TableCell
                      align="left"
                      style={{
                        top: 57,
                        minWidth: 150,
                        background: "#F2F1EB",
                        fontSize: "15px",
                        fontWeight: "bold",
                      }}
                    >
                      Status
                    </TableCell>
                    <TableCell
                      align="left"
                      style={{
                        top: 57,
                        minWidth: 150,
                        background: "#F2F1EB",
                        fontSize: "15px",
                        fontWeight: "bold",
                      }}
                    >
                      Owner Email
                    </TableCell>
                    <TableCell
                      align="left"
                      style={{
                        top: 57,
                        minWidth: 150,
                        background: "#F2F1EB",
                        fontSize: "15px",
                        fontWeight: "bold",
                      }}
                    >
                      Company Name
                    </TableCell>
                    <TableCell
                      align="left"
                      style={{
                        top: 57,
                        minWidth: 150,
                        background: "#F2F1EB",
                        fontSize: "15px",
                        fontWeight: "bold",
                      }}
                    >
                      Created Date
                    </TableCell>
                    <TableCell
                      align="left"
                      style={{
                        top: 57,
                        minWidth: 150,
                        background: "#F2F1EB",
                        fontSize: "15px",
                        fontWeight: "bold",
                      }}
                    >
                      Created Time
                    </TableCell>
                    {isSuperAdmin && (
                      <TableCell
                        align="left"
                        style={{
                          top: 57,
                          minWidth: 150,
                          background: "#F2F1EB",
                          fontSize: "15px",
                          fontWeight: "bold",
                        }}
                      >
                        Hidden for members
                      </TableCell>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Apps.map((app, i) => (
                    <TableRow
                      hover
                      role="checkbox"
                      key={i}
                      style={{
                        cursor: "pointer",
                        ...(highlightedWorkspaceIds?.has(Number(app.id))
                          ? { background: "#fff8e1", outline: "2px solid #f5b301" }
                          : {}),
                      }}
                      onClick={() => {
                        handleCardClick(app);
                      }}
                    >
                      <TableCell align="left">{app.name}</TableCell>
                      <TableCell align="left">
                        {app.paid ? (
                          <div
                            style={{
                              backgroundColor: "#d4edda",
                              color: "#155724",
                              padding: "8px 12px",
                              borderRadius: "5px",
                              textAlign: "center",
                              fontWeight: "bold",
                              border: "1px solid #c3e6cb",
                            }}
                          >
                            Paid
                          </div>
                        ) : (
                          <div
                            style={{
                              backgroundColor: "#f8d7da",
                              color: "#721c24",
                              padding: "8px 12px",
                              borderRadius: "5px",
                              textAlign: "center",
                              fontWeight: "bold",
                              border: "1px solid #f5c6cb",
                            }}
                          >
                            Unpaid
                          </div>
                        )}
                      </TableCell>
                      <TableCell align="left">
                        {app.nextOnlinePayment ? (
                          <span
                            style={{
                              color: "white",
                              background: "#1bf14dff",
                              padding: "4%",
                              borderRadius: "8%",
                            }}
                          >
                            Online
                          </span>
                        ) : (
                          <span
                            style={{
                              color: "white",
                              background: "#f11b22",
                              padding: "4%",
                              borderRadius: "8%",
                            }}
                          >
                            Offline
                          </span>
                        )}
                      </TableCell>
                      <TableCell align="left">
                        {app.status === "" ? (
                          "-"
                        ) : (
                          <span
                            style={{
                              color: "white",
                              background: "#f11b22",
                              padding: "4%",
                              borderRadius: "8%",
                            }}
                          >
                            {app.status}
                          </span>
                        )}
                      </TableCell>
                      <TableCell align="left">{app.owner_email}</TableCell>
                      <TableCell align="left">{app.company}</TableCell>
                      <TableCell align="left">
                        {app.createdAt
                          .split("T")[0]
                          .split("-")
                          .reverse()
                          .join("-")}
                      </TableCell>
                      <TableCell align="left">
                        {convertUTCToIST(app.createdAt.split("T")[1])}
                      </TableCell>
                      {isSuperAdmin && (
                        <TableCell
                          align="left"
                          // stopPropagation so clicking the switch doesn't
                          // also fire the row's "open this workspace" click
                          onClick={(e) => e.stopPropagation()}
                        >
                          <Switch
                            checked={!!hiddenById[app.id]}
                            onChange={(e) =>
                              toggleHidden(app.id, e.target.checked)
                            }
                            color="warning"
                          />
                        </TableCell>
                      )}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </>
      )}

      {/* EDIT MODAL */}

      {showEdit && (
        <>
          {" "}
          <div
            className={styles.backdrop}
            onClick={() => setShowEdit(false)}
          ></div>
          <div className={styles.modalContainer}>
            <Form className={styles.mainForm}>
              <h2 className={styles.marketPlaceHeading}>
                Edit MarketPlace Product Details
              </h2>

              <Form.Group controlId="formName" className={styles.formGroup}>
                <Form.Label>Workspace Name</Form.Label>
                <Form.Control
                  type="text"
                  value={workspace_name}
                  onChange={(e) => setWorkspace_name(e.target.value)}
                  placeholder="Enter name"
                  required
                  className={styles.formControl}
                />
              </Form.Group>

              <Form.Group
                controlId="formDescription"
                className={styles.formGroup}
              >
                <Form.Label>Description</Form.Label>
                <Form.Control
                  type="text"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  placeholder="Enter description"
                  required
                  className={styles.formControl}
                />
              </Form.Group>

              <Form.Group
                controlId="formPaymentType"
                className={styles.formGroup}
              >
                <Form.Label>Payment Type</Form.Label>
                <Form.Control
                  as="select"
                  value={paymentType}
                  onChange={(e) => setPaymentType(e.target.value)}
                  required
                  className={styles.formControl}
                >
                  <option value="US">US</option>
                  <option value="IN">IN</option>
                  <option value="GL">GLOBAL</option>
                </Form.Control>
              </Form.Group>

              {/* Additional Fields */}
              <Form.Group
                controlId="formWorkspaceName"
                className={styles.formGroup}
              >
                <Form.Label>Workspace Name</Form.Label>
                <Form.Control
                  type="text"
                  value={workspaceName}
                  onChange={(e) => setWorkspaceName(e.target.value)}
                  placeholder="Enter workspace name"
                  required
                  className={styles.formControl}
                />
              </Form.Group>

              <Form.Group
                controlId="formOwnerEmail"
                className={styles.formGroup}
              >
                <Form.Label>Owner Email</Form.Label>
                <Form.Control
                  type="email"
                  value={ownerEmail}
                  onChange={(e) => setOwnerEmail(e.target.value)}
                  placeholder="Enter owner email"
                  required
                  className={styles.formControl}
                />
              </Form.Group>

              <Form.Group controlId="formRegion" className={styles.formGroup}>
                <Form.Label>Region</Form.Label>
                <Form.Control
                  type="text"
                  value={region}
                  onChange={(e) => setRegion(e.target.value)}
                  placeholder="Enter region"
                  required
                  className={styles.formControl}
                />
              </Form.Group>

              <Form.Group
                controlId="formAvgSavings"
                className={styles.formGroup}
              >
                <Form.Label>Average Savings</Form.Label>
                <Form.Control
                  type="number"
                  value={avgSavings}
                  onChange={(e) => setAvgSavings(e.target.value)}
                  placeholder="Enter average savings"
                  required
                  className={styles.formControl}
                />
              </Form.Group>

              <Form.Group controlId="formCompany" className={styles.formGroup}>
                <Form.Label>Company</Form.Label>
                <Form.Control
                  type="text"
                  value={company}
                  onChange={(e) => setCompany(e.target.value)}
                  placeholder="Enter company"
                  required
                  className={styles.formControl}
                />
              </Form.Group>

              <Form.Group controlId="formAddress" className={styles.formGroup}>
                <Form.Label>Address</Form.Label>
                <Form.Control
                  type="text"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                  placeholder="Enter address"
                  required
                  className={styles.formControl}
                />
              </Form.Group>

              <Form.Group controlId="formTaxId" className={styles.formGroup}>
                <Form.Label>Tax ID</Form.Label>
                <Form.Control
                  type="text"
                  value={taxId}
                  onChange={(e) => setTaxId(e.target.value)}
                  placeholder="Enter tax ID"
                  required
                  className={styles.formControl}
                />
              </Form.Group>

              <Form.Group controlId="formPhone" className={styles.formGroup}>
                <Form.Label>Phone</Form.Label>
                <Form.Control
                  type="tel"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  placeholder="Enter phone number"
                  required
                  className={styles.formControl}
                />
              </Form.Group>

              <Form.Group
                controlId="formPaymentMethod"
                className={styles.formGroup}
              >
                <Form.Label>Payment Method</Form.Label>
                <Form.Control
                  type="text"
                  value={paymentMethod}
                  onChange={(e) => setPaymentMethod(e.target.value)}
                  placeholder="Enter payment method"
                  required
                  className={styles.formControl}
                />
              </Form.Group>

              <Form.Group
                controlId="formCustomerId"
                className={styles.formGroup}
              >
                <Form.Label>Customer ID</Form.Label>
                <Form.Control
                  type="text"
                  value={customerId}
                  onChange={(e) => setCustomerId(e.target.value)}
                  placeholder="Enter customer ID"
                  required
                  className={styles.formControl}
                />
              </Form.Group>

              <Form.Group
                controlId="formCustomerIdZoho"
                className={styles.formGroup}
              >
                <Form.Label>Customer ID (Zoho)</Form.Label>
                <Form.Control
                  type="text"
                  value={customerIdZoho}
                  onChange={(e) => setCustomerIdZoho(e.target.value)}
                  placeholder="Enter Zoho customer ID"
                  required
                  className={styles.formControl}
                />
              </Form.Group>

              <Form.Group
                controlId="formCustomerIdRzp"
                className={styles.formGroup}
              >
                <Form.Label>Customer ID (Razorpay)</Form.Label>
                <Form.Control
                  type="text"
                  value={customerIdRzp}
                  onChange={(e) => setCustomerIdRzp(e.target.value)}
                  placeholder="Enter Razorpay customer ID"
                  required
                  className={styles.formControl}
                />
              </Form.Group>

              <Button
                variant="primary"
                type="submit"
                className={styles.buttonSubmitcss}
              >
                Submit
              </Button>
            </Form>
          </div>{" "}
        </>
      )}
    </div>
  );
};

export default UserTable;
